(function () {
  var drawer, overlay, bodyEl, subtotalEl, checkoutBtn, emptyEl, footerEl, countBadge;
  var built = false;

  function formatMoney(cents) {
    return (cents / 100).toLocaleString(undefined, {
      style: 'currency',
      currency: window.Shopify && window.Shopify.currency ? window.Shopify.currency.active : 'GBP'
    });
  }

  function setHeaderHeightVar() {
    var header = document.querySelector('header, .header, [role="banner"], .shopify-section-header-group');
    var height = header ? header.getBoundingClientRect().height : 0;
    document.documentElement.style.setProperty('--ukps-header-h', height + 'px');
  }

  function build() {
    if (built) return;
    built = true;

    setHeaderHeightVar();
    window.addEventListener('resize', setHeaderHeightVar);

    overlay = document.createElement('div');
    overlay.className = 'ukps-drawer-overlay';

    drawer = document.createElement('div');
    drawer.className = 'ukps-drawer';
    drawer.innerHTML =
      '<div class="ukps-drawer__head">' +
        '<h2>Your Cart <span class="ukps-drawer__count" data-count>0</span></h2>' +
        '<button type="button" class="ukps-drawer__close" aria-label="Close cart">\u00d7</button>' +
      '</div>' +
      '<div class="ukps-drawer__body"></div>' +
      '<div class="ukps-drawer__empty" style="display:none;">' +
        '<div class="icon">\ud83d\uded2</div>' +
        '<p>Your cart is empty.</p>' +
        '<a href="/collections/all">Continue shopping</a>' +
      '</div>' +
      '<div class="ukps-drawer__footer">' +
        '<div class="ukps-drawer__subtotal-row"><span>Subtotal</span><span data-subtotal>\u00a30.00</span></div>' +
        '<p class="ukps-drawer__note">Taxes included. Discounts and shipping calculated at checkout.</p>' +
        '<button type="button" class="ukps-drawer__checkout">Check out</button>' +
        '<button type="button" class="ukps-drawer__viewcart">View full cart</button>' +
      '</div>';

    document.body.appendChild(overlay);
    document.body.appendChild(drawer);

    bodyEl = drawer.querySelector('.ukps-drawer__body');
    emptyEl = drawer.querySelector('.ukps-drawer__empty');
    footerEl = drawer.querySelector('.ukps-drawer__footer');
    subtotalEl = drawer.querySelector('[data-subtotal]');
    countBadge = drawer.querySelector('[data-count]');
    checkoutBtn = drawer.querySelector('.ukps-drawer__checkout');

    drawer.querySelector('.ukps-drawer__close').addEventListener('click', closeDrawer);
    overlay.addEventListener('click', closeDrawer);
    checkoutBtn.addEventListener('click', function () { window.location.href = '/checkout'; });
    drawer.querySelector('.ukps-drawer__viewcart').addEventListener('click', function () { window.location.href = '/cart'; });
    document.addEventListener('keyup', function (e) { if (e.key === 'Escape') closeDrawer(); });
  }

  function openDrawer() {
    build();
    setHeaderHeightVar();
    overlay.classList.add('is-open');
    drawer.classList.add('is-open');
  }

  function closeDrawer() {
    if (!built) return;
    overlay.classList.remove('is-open');
    drawer.classList.remove('is-open');
  }

  function getCartIconLink() {
    var icon = document.querySelector('#cart-icon-bubble');
    if (!icon) return null;
    return icon.closest('a') || icon;
  }

  function updateHeaderBubble(count) {
    var link = getCartIconLink();
    if (!link) return;

    var bubbleWrap = link.querySelector('.cart-count-bubble');

    if (count > 0) {
      if (!bubbleWrap) {
        bubbleWrap = document.createElement('div');
        bubbleWrap.className = 'cart-count-bubble';
        bubbleWrap.innerHTML =
          '<span aria-hidden="true"></span>' +
          '<span class="visually-hidden">Cart item count</span>';
        link.appendChild(bubbleWrap);
      }
      var numberEl = bubbleWrap.querySelector('span[aria-hidden="true"]');
      if (numberEl) numberEl.textContent = count;
      bubbleWrap.style.display = '';
    } else if (bubbleWrap) {
      bubbleWrap.style.display = 'none';
    }
  }

  function renderRow(item, index) {
    build();
    var row = document.createElement('div');
    row.className = 'ukps-drawer__row';
    row.setAttribute('data-row', index + 1);

    var variantHtml = item.variant_title ? '<div class="ukps-drawer__row-variant">' + item.variant_title + '</div>' : '';

    row.innerHTML =
      '<a href="' + item.url + '" class="ukps-drawer__row-media">' +
        (item.image ? '<img src="' + item.image + '" alt="">' : '') +
      '</a>' +
      '<div class="ukps-drawer__row-info">' +
        '<a href="' + item.url + '" class="ukps-drawer__row-title">' + item.product_title + '</a>' +
        variantHtml +
        '<div class="ukps-drawer__row-qty">' +
          '<button type="button" data-minus>\u2212</button>' +
          '<span>' + item.quantity + '</span>' +
          '<button type="button" data-plus>+</button>' +
        '</div>' +
      '</div>' +
      '<div class="ukps-drawer__row-end">' +
        '<div class="ukps-drawer__row-price">' + formatMoney(item.final_line_price) + '</div>' +
        '<button type="button" class="ukps-drawer__row-remove" data-remove>Remove</button>' +
      '</div>';

    row.querySelector('[data-minus]').addEventListener('click', function () { changeLine(index + 1, item.quantity - 1); });
    row.querySelector('[data-plus]').addEventListener('click', function () { changeLine(index + 1, item.quantity + 1); });
    row.querySelector('[data-remove]').addEventListener('click', function () { changeLine(index + 1, 0); });

    return row;
  }

  function renderCart(cart) {
    build();
    updateHeaderBubble(cart.item_count);
    if (countBadge) countBadge.textContent = cart.item_count;

    if (!cart.items.length) {
      bodyEl.style.display = 'none';
      footerEl.style.display = 'none';
      emptyEl.style.display = 'block';
      return;
    }

    bodyEl.style.display = '';
    footerEl.style.display = '';
    emptyEl.style.display = 'none';

    bodyEl.innerHTML = '';
    cart.items.forEach(function (item, index) {
      bodyEl.appendChild(renderRow(item, index));
    });

    subtotalEl.textContent = formatMoney(cart.total_price);
  }

  function refreshCart() {
    return fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        renderCart(cart);
        return cart;
      });
  }

  function changeLine(line, quantity) {
    var row = bodyEl.querySelector('[data-row="' + line + '"]');
    if (row) row.classList.add('is-updating');

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: Math.max(0, quantity) })
    })
      .then(function (res) { return res.json(); })
      .then(function (cart) { renderCart(cart); })
      .catch(function () { if (row) row.classList.remove('is-updating'); });
  }

  function addToCartRaw(body) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: body instanceof FormData ? undefined : { 'Content-Type': 'application/json' },
      body: body
    })
      .then(function (res) {
        if (!res.ok) return res.json().then(function (err) { throw err; });
        return refreshCart();
      })
      .then(function (cart) {
        openDrawer();
        return cart;
      });
  }

  window.UKPSCart = {
    open: openDrawer,
    close: closeDrawer,
    refresh: refreshCart,
    addToCart: function (variantId, quantity) {
      return addToCartRaw(JSON.stringify({ items: [{ id: variantId, quantity: quantity || 1 }] }));
    }
  };

  document.addEventListener('DOMContentLoaded', function () {
    var cartLink = getCartIconLink();
    if (cartLink) {
      cartLink.addEventListener('click', function (e) {
        e.preventDefault();
        build();
        refreshCart();
        openDrawer();
      });
    }

    // Intercept ANY standard Shopify "add to cart" form on the site
    // (product pages included) in the CAPTURE phase, so we run before
    // Taste's own product-form.js gets a chance to handle it and force
    // a redirect to the cart page.
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || !form.action || form.action.indexOf('/cart/add') === -1) return;
      e.preventDefault();
      e.stopImmediatePropagation();

      var submitBtn = form.querySelector('[type="submit"]');
      if (submitBtn) submitBtn.setAttribute('aria-disabled', 'true');

      addToCartRaw(new FormData(form))
        .catch(function () {
          window.location.href = '/cart';
        })
        .finally(function () {
          if (submitBtn) submitBtn.removeAttribute('aria-disabled');
        });
    }, true);

    refreshCart();
  });
})();
